import { render, staticRenderFns } from "./SignDocumentModal.vue?vue&type=template&id=89b43de8&"
import script from "./SignDocumentModal.vue?vue&type=script&lang=ts&"
export * from "./SignDocumentModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports